var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAllItems = function SvgAllItems(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2H15V3H10V2ZM22 3H18V2H22C22.5523 2 23 2.44772 23 3V7H22V3ZM22 18V22H18V23H22C22.5523 23 23 22.5523 23 22V18H22ZM22 15H23V10H22V15ZM15 22H10V23H15V22ZM3 2H7V3H3V7H2V3C2 2.44772 2.44772 2 3 2ZM2 10H3V15H2V10ZM3 18V22H7V23H3C2.44772 23 2 22.5523 2 22V18H3ZM10 7H7V10H10V7ZM7 6H6V7V10V11H7H10H11V10V7V6H10H7ZM7 15H10V18H7V15ZM6 14H7H10H11V15V18V19H10H7H6V18V15V14ZM18 7H15V10H18V7ZM15 6H14V7V10V11H15H18H19V10V7V6H18H15ZM15 15H18V18H15V15ZM14 14H15H18H19V15V18V19H18H15H14V18V15V14Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAllItems);
export default ForwardRef;